// Full-width dashboard card; title treatment matches Stage 2 Leaders
// (text-base semibold, colored lucide icon in front).
export default function DashboardSection({ title, icon: Icon, iconClassName = '', testId, children, bodyClassName = '', borderClassName = 'border-border' }) {
  return (
    <section className={`rounded-xl border ${borderClassName} bg-card p-4 sm:p-5`} data-testid={testId}>
      <div className="flex items-center gap-2 mb-3 min-w-0">
        {Icon && <Icon className={`w-4 h-4 shrink-0 ${iconClassName}`} aria-hidden />}
        <h3 className="text-[18px] font-semibold tracking-tight truncate">{title}</h3>
      </div>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}
